if (!customElements.get('pdp-slider')) {
  customElements.define('pdp-slider', class PdpSlider extends HTMLElement {
    constructor() {
      super();

      this.onThumbClick = this.onThumbClick.bind(this);
      this.onSlideChanged = this.onSlideChanged.bind(this);
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        thumbButtons: this.querySelectorAll('[id^="GalleryThumbnails"] button'),
        dots: this.querySelectorAll('[id^="Dot"]')
      }
      this.lastDotSelected = 0;
      
    }

    bindEvents() {
      this.viewerEmbla.on("select", this.onSlideChanged);
      this.onSlideChanged()
      this.elements.thumbButtons.forEach((button) => {
        button.addEventListener("click", this.onThumbClick, false);
      });
    }

    connectedCallback() {
      const plugins = [EmblaCarouselWheelGestures()] // Plugins
      const viewerOptions = { loop: true, speed: 20, align: 'center', draggable: true }
      const thumbsOptions = { containScroll: true, loop: false, speed: 20, align: 0, draggable: true }

      if (!this.elements.viewer.hasAttribute('data-slider')) return;
      this.viewerEmbla = EmblaCarousel(this.elements.viewer, viewerOptions, plugins)
      this.thumbsEmbla = EmblaCarousel(this.elements.thumbnails, thumbsOptions, plugins)
      this.bindEvents()
    }

    disconnectedCallback() {
      if (this.viewerEmbla) this.viewerEmbla.destroy();
      if (this.thumbsEmbla) this.thumbsEmbla.destroy();
    }

    onThumbClick(e) {
      if (!this.viewerEmbla) return;
      this.viewerEmbla.scrollTo(e.currentTarget.dataset.index);
    }

    selectImageById(id) {
      const slide = this.querySelector('#' + id)
      if (!this.viewerEmbla) return;
      this.viewerEmbla.scrollTo(slide.dataset.mediaPosition);
    }

    onSlideChanged() {
      const index = this.viewerEmbla.selectedScrollSnap();
      this.selectThumbBtn(index);
      this.selectMainImage(index);
      this.selectDots(index);
    }

    selectDots(index){
      this.elements.dots[this.lastDotSelected].classList.remove('selected');
      this.elements.dots[index].classList.add('selected');
      this.lastDotSelected = index;
    }

    selectThumbBtn(index) {
      this.thumbsEmbla.scrollTo(index);
      const currentButton = this.thumbsEmbla.containerNode().querySelector(`[data-index="${index}"]`)
      this.elements.thumbButtons.forEach((button) => {
        if (button == currentButton) {
          currentButton.setAttribute('aria-current', true);
          currentButton.classList.remove('opacity-60');
          currentButton.classList.add('opacity-100', 'blur-none');
        } else {
          button.removeAttribute('aria-current');
          button.classList.remove('opacity-100', 'blur-none');
          button.classList.add('opacity-60');
        }
      })

    }

    selectMainImage(index) {
      const currentSlide = this.viewerEmbla.slideNodes()[index]
      this.viewerEmbla.slideNodes().forEach((node) => {
        if (node == currentSlide) {
          currentSlide.setAttribute('aria-current', true);
        } else {
          node.removeAttribute('aria-current');
        }
      })
    }

  });
}
